import path from 'path'
import { ParsedGuideVersionConfig } from '../schemas'
import { walkSidebarItems } from '../walk'

export function getSidebarFilePaths({
	versionConfig,
	versionFolderPath,
}: {
	versionConfig: ParsedGuideVersionConfig
	versionFolderPath: string
}) {
	const sidebarPaths: string[] = []
	walkSidebarItems(versionConfig.sidebar, (item) => {
		if (item.type === 'page') {
			sidebarPaths.push(path.join(versionFolderPath, item.path))
		}

		return null
	})

	return sidebarPaths
}
